import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'th[sortable]',
  standalone: true,
  host: {
    'class': 'font-medium text-sm cursor-pointer hover:bg-base-300/50 select-none',
  },
  template: `
    <span class="flex items-center gap-1">
      <ng-content></ng-content>
      @if (sortBy === field) {
        @if (sortOrder === 'asc') {
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd" />
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        }
      }
    </span>
  `,
})
export class SortableHeaderComponent {
  @Input() field: string = '';
  @Input() sortBy: string = '';
  @Input() sortOrder: 'asc' | 'desc' = 'asc';
  @Output() sort = new EventEmitter<string>();

  @HostListener('click')
  onClick() {
    this.sort.emit(this.field);
  }
}
